import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { get } from 'lodash';
import { pipe, switchMap } from 'rxjs';
import { AvailabilityDataService } from 'src/shared/services/availability.data.service/availability.data.service';
import { Tenant } from 'src/environments/evironment.interface';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';
import { bookingexternal } from 'src/shared/services/client/client';
import { RemoteConfigService } from 'src/shared/services/remote-config/remote-config.service';
import { withTenant } from '../features/tenant/tenant.feature';

export const ChatAvailabilityStore = signalStore(
  withTenant(),
  withState({
    chatAvailabilityResponse: null as bookingexternal.ChatAvailabilityResponse | null,
    available: false,
    busy: false,
    next_chat_available_in_minutes: null as number | null,
    refreshInterval: 15000, // 15 seconds
  }),
  withComputed(({ tenant }) => {
    const auth = inject(AuthenticationService);
    const remoteConfig = inject(RemoteConfigService);

    return {
      disabled: computed(() =>
        isChatDisabled(
          tenant(),
          auth.isStaff(),
          auth.isLoggedIn(),
          remoteConfig.configurations()?.get('chat_cta') === 'true',
          remoteConfig.configurations()?.get('chat_cta_afi') === 'true'
        )
      ),
    };
  }),
  withMethods((store, availabilityDataService = inject(AvailabilityDataService)) => ({
    setChatAvailability: rxMethod<string | undefined>(
      pipe(
        switchMap((chatServiceDocId) => availabilityDataService.ChatAvailability(chatServiceDocId || '')),
        tapResponse({
          next: (response) => {
            patchState(store, { ...response, chatAvailabilityResponse: response });
          },
          error: (error: any) => {
            console.error('Error fetching chat availability:', error);
            patchState(store, {
              available: false,
              busy: false,
              next_chat_available_in_minutes: null,
              chatAvailabilityResponse: null,
            });
          },
        })
      )
    ),
  }))
);

function isChatDisabled(
  tenant: Tenant | null,
  isStaff: boolean,
  isLoggedIn: boolean,
  remoteConfigChatEnabled: boolean,
  afiChatEnabled: boolean
): boolean {
  if (!isLoggedIn || !remoteConfigChatEnabled) return true;
  if (isStaff) return false;
  if (get(tenant, 'friendly_id') === 'animalfriends') return !afiChatEnabled;
  return false;
}
